module.exports = __webpack_public_path__ + "favicon/favicon_180.60004a0b.png";